import React from "react";
import { I18n } from "@aws-amplify/core";
import { withStyles } from "@material-ui/styles";
import { get, size, filter, sum, map, has, concat } from "lodash";

import Grid from "@material-ui/core/Grid";
import TableRow from "@material-ui/core/TableRow";

import TagColor from "../Common/TagColor";
import ProfileLink from "../Common/ProfileLink";
import TableCellStyled from "../Common/TableCellStyled";
import EllipsedTextNew from "../Common/EllipsedTextNew";

import { formatDate } from "../../utils/date";
import { getLovValue } from "../../utils/profile";
import { isEventGroup } from "../../utils/eventGroups";

import images from "../../assets/img/images";
import colors from "../../assets/style/colors";
import { CircularProgress } from "@material-ui/core";

const styles = {
  tableRow: {
    cursor: "pointer",
    "&:hover": {
      backgroundColor: `${colors.lightGreenBg} !important`,
    },
  },
  topBorderedCell: {
    "& td": {
      borderTop: `2px solid ${colors.primary}`,
    },
  },
  bottomBorderedCell: {
    "& td": {
      borderBottom: `2px solid ${colors.primary}`,
    },
  },
};

const EventGroupRow = withStyles(styles)((props) => {
  const {
    classes,
    item,
    language,
    index,
    level,
    eventGroupId,
    lov,
    onSelect,
    selectedEvent,
    expandedEventGroup,
    isLast,
    dialog,
    loadChildEventGroups,
    fetchingChild,
    myprofile
  } = props;
  const [expand, setExpand] = React.useState(false);

  const hasChildEvents = size(get(item, ["events"])) > 0;
  const hasChildEventGroups = size(get(item, ["childEventGroups"])) > 0;
  const hasChildren = hasChildEventGroups || hasChildEvents;

  const active = selectedEvent === get(item, ["id"]);

  const expandRow = (newExpand) => {
    if (
      isEventGroup(get(item, ["id"])) &&
      level === 0 &&
      !has(item, ["childEventGroups"])
    ) {
      loadChildEventGroups(get(item, ["id"]));
    }
    setExpand(newExpand);
  };

  const renderDataCell = (content, style = {}) => {
    return (
      <TableCellStyled style={style}>
        <span className="text-54">{content}</span>
      </TableCellStyled>
    );
  };

  return (
    <>
      <TableRow
        onClick={() => {
          onSelect(item);
          expandRow(active ? !expand : true);
        }}
        className={`${classes.tableRow} ${
          expand && hasChildren && level === 0 ? classes.topBorderedCell : ""
        } ${
          isLast && level !== 0 && (!expand || !hasChildren)
            ? classes.bottomBorderedCell
            : ""
        }`}
        style={{
          backgroundColor: active
            ? colors.activeYellow
            : index % 2 === 0
            ? colors.white
            : colors.tableDarkBg,
        }}
      >
        <TableCellStyled
          style={{
            borderLeft:
              expandedEventGroup || (expand && hasChildren && level === 0)
                ? `2px solid ${colors.primary}`
                : "none",
          }}
        >
          <Grid
            container
            wrap="nowrap"
            alignItems="center"
            style={{
              paddingLeft: `${30 * level}px`,
            }}
          >
            <Grid
              item
              style={{
                width: "30px",
                textAlign: "center",
              }}
            >
              {hasChildren && (
                <img
                  src={expand ? images.bottomArrow : images.rightArrow}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (hasChildren) expandRow(!expand);
                  }}
                  alt="expand_arrow"
                  style={{
                    marginRight: "8px",
                    cursor: hasChildren ? "pointer" : "default",
                  }}
                />
              )}
            </Grid>
            <Grid
              item
              className={
                isEventGroup(get(item, ["id"])) ? "text-87" : "text-54"
              }
              onClick={() => {
                onSelect(item);
                expandRow(active ? !expand : true);
              }}
              id={get(item, ["id"])}
              style={{
                fontWeight: isEventGroup(get(item, ["id"])) ? 500 : 400,
                cursor: "pointer",
              }}
            >
              {`${get(item, ["type", `name_${language}`])} ${
                hasChildren ? `(${size(get(item, ["events"]))})` : ""
              }`}
            </Grid>
            {fetchingChild === get(item, ["id"]) && (
              <Grid item style={{ marginLeft: "10px" }}>
                <CircularProgress size={18} />
              </Grid>
            )}
          </Grid>
        </TableCellStyled>
        <TableCellStyled>
          <span className="text-54">{get(item, ["active"]) ? I18n.get("events_yes") : I18n.get("events_no")}</span>
        </TableCellStyled>
        {renderDataCell(formatDate(get(item, ["created_on"])))}
        {renderDataCell(get(item, ["created_by"]))}
        {renderDataCell(
          isEventGroup(get(item, ["id"]))
            ? get(item, ["id"])
            : get(item, ["group", "id"])
        )}
        <TableCellStyled>
          {get(item, ["profile"]) && (
            <Grid container style={{ marginLeft: "-8px" }}>
              <ProfileLink
                profile={get(item, ["profile"])}
                myprofile={myprofile}
                noTitle
                containerStyle={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  fontSize: "1em",
                  color: colors.black54,
                }}
              />
            </Grid>
          )}
        </TableCellStyled>
        <TableCellStyled>
          {get(item, ["profile", "tag"]) && (
            <Grid container alignItems="center" wrap="nowrap">
              <TagColor
                color={`#${get(item, ["profile", "tag", "color_rgb"])}`}
              />
              <Grid item className="text-54">
                {get(item, ["profile", `tag_name_${language}`])}
              </Grid>
            </Grid>
          )}
        </TableCellStyled>
        {!dialog &&
          renderDataCell(
            get(item, ["risk_level"]) !== undefined &&
              get(lov, ["riskLevel"]) &&
              getLovValue("riskLevel", get(item, ["risk_level"]), lov, language)
          )}
        {!dialog &&
          renderDataCell(
            isEventGroup(get(item, ["id"]))
              ? get(item, ["events", 0, "zone", "company", "name"])
              : get(item, ["zone", "company", "name"])
          )}
        {!dialog &&
          renderDataCell(
            isEventGroup(get(item, ["id"]))
              ? get(item, ["events", 0, "zone", "site", "name"])
              : get(item, ["zone", "site", "name"])
          )}
        {!dialog &&
          renderDataCell(
            isEventGroup(get(item, ["id"]))
              ? get(item, ["events", 0, "zone", "name"])
              : get(item, ["zone", "name"])
          )}
        {renderDataCell(
          isEventGroup(get(item, ["id"]))
            ? size(
                filter(
                  get(item, ["events", 0, "attributes"]),
                  (attr) => attr.id === 10
                )
              ) > 0 && (
                <EllipsedTextNew
                  text={get(
                    filter(
                      get(item, ["events", 0, "attributes"]),
                      (attr) => attr.id === 10
                    ),
                    [0, "value"]
                  )}
                  maxWidth={135}
                />
              )
            : size(
                filter(get(item, ["attributes"]), (attr) => attr.id === 10)
              ) > 0 && (
                <EllipsedTextNew
                  text={get(
                    filter(get(item, ["attributes"]), (attr) => attr.id === 10),
                    [0, "value"]
                  )}
                  maxWidth={135}
                />
              )
        )}
        {renderDataCell(
          isEventGroup(get(item, ["id"]))
            ? get(item, ["events", 0, "device", "name"])
            : get(item, ["device", "name"]),
          {
            borderRight:
              expandedEventGroup || (expand && hasChildren && level === 0)
                ? `2px solid ${colors.primary}`
                : "none",
          }
        )}
      </TableRow>
      {expand &&
        map(
          concat(
            get(item, ["childEventGroups"]) || [],
            get(item, ["events"]) || []
          ),
          (e, i) => (
            <EventGroupRow
              language={language}
              item={e}
              key={get(e, ["id"])}
              index={sum([index, i, 1])}
              level={sum([level, 1])}
              eventGroupId={eventGroupId}
              onSelect={onSelect}
              selectedEvent={selectedEvent}
              expandedEventGroup={level === 0 ? expand : expandedEventGroup}
              isLast={
                isLast &&
                i ===
                  size(
                    concat(
                      get(item, ["childEventGroups"]) || [],
                      get(item, ["events"]) || []
                    )
                  ) -
                    1
              }
              dialog={dialog}
              loadChildEventGroups={loadChildEventGroups}
            />
          )
        )}
    </>
  );
});

export default EventGroupRow;
